import html from "./RequiredSurvey.html"
import "./RequiredSurvey.css"
import "../ProjectWarning.css"
import "../SurveyCompletion/SurveyContainer.js"
import "../SurveyCompletion/ConsentSurveyContainer.js"
import "../SurveyCompletion/UpdateEmailSurveyContainer.js"
import { persistConsentResult, persistLinkConsentResult } from "../../../api/survey/surveyResult"
import { captureDeviceInfo } from "../../../helpers/MyDataHelps/participantDeviceInfo";

$(document).ready(function () {
    if (!$(".required-survey-container").length) { return; }

    var configuration = JSON.parse(document.getElementById('AntiXssRequiredSurveyConfigurationInit').textContent);

    var module = angular.module("RequiredSurveyModule", ['CareEvWidgets', 'ngSanitize', 'ResearchKitApplicationModule', 'ngCookies', 'pascalprecht.translate', 'ngAria']);
    module.constant("WebViewStepFrameUrl", configuration.WebViewStepFrameUrl)
        .constant("availableLocales", configuration.AvailableLocales);

    module.component('requiredSurvey', {
        template: html,
        controller: 'RequiredSurveyController',
        controllerAs: 'vm'
    });

    module.controller("RequiredSurveyController", ["$scope", "$window", "$translate", "$http", "ceUrl", "$timeout",
        function ($scope, $window, $translate, $http, ceUrl, $timeout) {
            if (configuration.ErrorMessage) {
                alert(ErrorMessage);
                return;
            }

            $scope.participantIdentifier = configuration.ParticipantIdentifier;
            $scope.linkKey = configuration.LinkKey;

            $scope.closeWarning = function () {
                $scope.warningMessage = null;
            }

            $scope.currentLanguage = $translate.use();
            if (configuration.SurveyID) {
                $scope.survey = { surveyID: configuration.SurveyID, projectRecordAuthorityCode: configuration.ProjectRecordAuthorityCode };
            } else {
                showProjectConsent();
            }

            function showProjectConsent() {
                $scope.warningMessage = configuration.Project ? configuration.Project.WarningMessage : null;
                if (configuration.LinkKey) {
                    $scope.consentLinkKey = configuration.LinkKey;
                } else {
                    $scope.consentProjectID = configuration.Project.ID;
                }
                $timeout();
            }

            $window.addEventListener("message", webViewMessageHandler);
            function webViewMessageHandler(event) {
                if (event.origin !== "https://careevolutionframe.com") return;
                if (event.data && event.data.name === "UpdateEmail") {
                    $scope.$apply(function () {
                        $scope.showUpdateEmailSurvey = true;
                    });
                }
            }

            var untrustedJoinConfirmation = "";
            $translate('unlicensed-join-project-confirm')
                .then(function (translatedValue) {
                    untrustedJoinConfirmation = translatedValue;
                });

            $scope.getConfirmationMessage = function () {
                if ( configuration.Project && !configuration.Project.OrganizationIsTrusted) {
                    return untrustedJoinConfirmation + " " + configuration.Project.DisplayName + "?";
                }
            }

            $scope.$on("surveyFinished", function (event, reason, taskResult, completionAction) {
                if ($scope.showUpdateEmailSurvey) {
                    if (reason === "Closed") {
                        ActiveLogout.Logout(true);
                    }
                    else {
                        $window.location.reload();
                    }
                }
                else if (!taskResult) {
                    ActiveLogout.Logout(true);
                }
                else {
                    if ($scope.survey) {
                        $scope.survey = null;
                        if (!configuration.Project) {
                            $window.location = configuration.SurveyFinishedRedirect;
                        }
                        else {
                            showProjectConsent();
                        }
                    }
                    else {
                        $http.put(ceUrl.make("api/researchkit/studyparticipant/userpreference/mdh.selectedproject"), { projectID: configuration.Project.ID }).finally(function () {
                            $window.location = configuration.SurveyFinishedRedirect;
                        });
                    }
                }
            });

            $scope.captureDeviceInfo = function () {
                captureDeviceInfo();
            };
        }
    ]);

    module.config(["$translateProvider", "translateConfigurationProvider", function ($translateProvider, translateConfigurationProvider) {

        translateConfigurationProvider.$get().configure($translateProvider, configuration.AvailableLocales);
    }]);

    angular.bootstrap($(".required-survey-container"), ["RequiredSurveyModule"]);
});